import { createStandaloneToast } from "@chakra-ui/react";
import React from "react";
import actions from "../redux/Actions";
import { store, persistor } from "../redux/Store";
import { BASE_URL } from "../Constants/apiConstant";

const { toast: standaloneToast } = createStandaloneToast();
// Claude: guard prevents duplicate toasts when multiple concurrent 401s fire during the delay 28-04-2026
let _sessionExpiredPending = false;

const _doLogout = (redirectTo: string) => {
  const token = (store.getState() as any).user?.token;
  if (token) {
    fetch(`${BASE_URL}/auth/logout`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      keepalive: true,
    }).catch(() => {});
  }
  store.dispatch(actions.user.set({ token: null, user: null, role: null }));
  persistor.purge();
  sessionStorage.clear();
  window.location.href = redirectTo;
};

// Claude: clears session, purges redux-persist localStorage, redirects to login 06-03-2026
// Claude: optional redirectTo param — admin logout passes /admin/login 27-03-2026
// Claude: fires keepalive POST /auth/logout before redirect so backend session is terminated even on 401 auto-logout 26-04-2026
// Claude: optional reason='expired' — shows toast and delays redirect by 2.5s instead of immediate logout 28-04-2026
export const handleLogout = (redirectTo = "/login", reason?: "expired") => {
  if (reason === "expired" && !_sessionExpiredPending) {
    _sessionExpiredPending = true;
    standaloneToast({
      position: "top",
      duration: 2500,
      isClosable: false,
      containerStyle: { marginTop: "40vh" },
      render: () =>
        React.createElement(
          "div",
          {
            style: {
              background: "#FFF3CD",
              color: "#856404",
              padding: "10px 18px",
              borderRadius: "8px",
              fontSize: "13px",
              fontWeight: 400,
              textAlign: "center" as const,
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            },
          },
          "Your session has expired. Please log in again."
        ),
    });
    setTimeout(() => _doLogout(redirectTo), 2500);
    return;
  }
  _doLogout(redirectTo);
};
